// Modules
import { gql } from '@apollo/client'

export const VerifyPreUserRegistration = gql`
    query viewerSearch($patient: PatientSearch) {
        viewerSearch(patient: $patient) {
            id
            phone
            biologicalSex
            cep
            phoneContacts {
                id
                contactType
                value
            }
            emailContacts {
                id
                value
                contactType
            }
        }
    }
`
